<template>
  <div class="register-container">
    <AuthTabs active="register" />
    <div class="col-md-12 text-left d-flex justify-content-center">
      <signUpstudent />
    </div>
  </div>
</template>

<script>
import signUpstudent from "../components/signUpstudent.vue";
import AuthTabs from "../components/AuthTabs.vue";
import user from "../mixins/user";

export default {
  name: "Registration",
  mixins: [user],
  components: {
    signUpstudent,
    AuthTabs,
  },
};
</script>
<style lang="postcss" scoped>
.register-container {
  width: 100%;
  padding: 80px 20px;
  font-family: "Roboto", sans-serif;
}
</style>
